import React from 'react';
import { DashboardTemplate } from './Dashboard';
import {ORSMasterListing} from "components/globals/ORSMasterListing"

export default function Dashboard() {

	const sections = [
		{
			params: {
				elementId: "notes", 
				headingTitle: "Your Car Notes",
				headingButtonUrl: null,
				headingButtonText: null,
				apiPath: "protected/notes",
				omit: "none",
				limit: "12",
				type: "note", 
				pagination: true,
				protected: true,
				createButton: true,
				createButtonPath: "/new/note"
			},
			displayOptions: {
				layout: "row",
				largeCard: true,
				yoursBadge: false,
				typeBadge: false,
				categoryBadge: false,
				userBadge: false,
				carBadge: false,
				carDetails: false,
				dateDetails: false,
				rowColumns: true,
				mobileCarousel: false,
				likes: true,
				showIfNone: true,
			},
		},
		{
			params: {
				elementId: "resources", 
				headingTitle: "Your Resources",
				headingButtonUrl: null,
				headingButtonText: null,
				apiPath: "protected/resources",
				omit: "none",
				limit: "12",
				type: "resource", 
				pagination: true,
				protected: true,
				createButton: true,
				createButtonPath: "/new/resource"
			},
			displayOptions: {
				layout: "row",
				largeCard: true,
				yoursBadge: false,
				typeBadge: false,
				categoryBadge: false,
				userBadge: false,
				carBadge: false,
				carDetails: false,
				dateDetails: false,
				rowColumns: true,
				mobileCarousel: false,
				likes: true,
				showIfNone: true,
			},
		},
	];

	return (
		<>
			<DashboardTemplate title="My Notes & Resources">
				{sections.map(({params, displayOptions}) => (
					<ORSMasterListing key={params.elementId} params={params} displayOptions={displayOptions} />
				))}
			</DashboardTemplate>
		</>
	);
}